import axios from "../utils/axios";

const API_URL = process.env.REACT_APP_API_URL + "/v1/admin";

const getLogs = (pageNo = 0, pageSize = 5, date = null, name = null, config = {}) => {
    const params = new URLSearchParams({
        pageNo,
        pageSize
    });

    if (date instanceof Date) {
        params.append('date', date.toISOString().split('T')[0]);
    } else if (typeof date === 'string' && date) {
        params.append('date', date);
    }

    if (typeof name === 'string' && name.trim()) {
        params.append('name', name.trim());
    }

    return axios.get(`${API_URL}/scheduler-logs?${params}`, config);
};

const logsService = {
    getLogs
};

export default logsService;
